export default '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="512" height="512">\
    <path fill="var(--color)" d="M23,19V17A11.01,11.01,0,0,0,13,6.051V4.723a2,2,0,1,0-2,0V6.051A11.01,11.01,0,0,0,1,17v2H0v2H24V19ZM3,17C3.473,5.066,20.531,5.075,21,17v2H3Z"/>\
</svg>'
